import { siteConfig } from "../config/siteConfig";

export default function FloatingWhatsApp() {
  const { contact, whatsappDefaultMessage } = siteConfig;
  const href = `https://wa.me/message/BZL7M62MZMM6J1?text=${encodeURIComponent(
    whatsappDefaultMessage
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl pulse-green hover:scale-110 transition-transform"
    >
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="w-7 h-7"
        aria-hidden="true"
      >
        <path d="M20.52 3.48A11.85 11.85 0 0012 0C5.37 0 .02 5.34.02 11.96c0 2.11.55 4.16 1.6 5.96L0 24l6.27-1.64a11.94 11.94 0 005.73 1.46h.01c6.62 0 11.97-5.34 11.97-11.96 0-3.19-1.24-6.19-3.46-8.38zM12 21.78h-.01a9.84 9.84 0 01-5.02-1.38l-.36-.21-3.72.97.99-3.62-.23-.37A9.82 9.82 0 012.16 11.96C2.16 6.53 6.57 2.13 12 2.13a9.8 9.8 0 016.99 2.9 9.79 9.79 0 012.89 6.93c0 5.43-4.41 9.82-9.88 9.82zm5.43-7.36c-.3-.15-1.76-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.16c-.17.2-.35.22-.65.07-.3-.15-1.26-.47-2.4-1.49-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.49 1.07 2.89 1.22 3.09c.15.2 2.11 3.22 5.11 4.51.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.35z" />
      </svg>
    </a>
  );
}
